module.exports = __webpack_public_path__ + "static/media/OpenAI.a22da4ad.svg";